var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v(" 공모전 ")]),_c('div',[_c('competition-list-component',{attrs:{"competitionType":`competition`}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }